import React, { memo } from "react";
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatNumber } from "helpers/getNumberFormats";
import { InvoiceGrid } from "./styled-components";
import {
  ROW_COLUMNS,
  ROW_GRID_COLUMNS,
  accentLabelStyle,
  labelCellStyle,
  labelTextStyle,
} from "./invoiceLayout";
import { TaxBreakdownAccordion } from "./TaxBreakdownAccordion";
import { buildCreLicenseLabel } from "./invoiceTotals";

/**
 * Fila de un permiso. Comparte la cuadricula de las filas de totales, asi que
 * su etiqueta y sus dos importes quedan en las mismas columnas; el desglose
 * se despliega debajo sin mover nada de la fila.
 */
export const CreLicenseRow = memo(
  ({ license, expanded, onToggle, selectedPayments, onTogglePayment, originalPayments }) => {
    const {
      creLicense,
      postalCode,
      total,
      quantity,
      taxBreakdown = [],
    } = license;

    return (
      <Grid item xs={12} mt={1} mb={1}>
        <Grid container spacing={1} alignItems="center" columns={ROW_GRID_COLUMNS}>
          <InvoiceGrid item xs={ROW_GRID_COLUMNS} sm={ROW_COLUMNS.label}>
            <Box sx={labelCellStyle}>
              <Typography sx={{ ...labelTextStyle, ...accentLabelStyle }}>
                {buildCreLicenseLabel({ creLicense, postalCode })}
              </Typography>

              <IconButton
                size="small"
                onClick={onToggle}
                aria-label={expanded ? "Ocultar desglose" : "Ver desglose"}
                sx={{
                  flexShrink: 0,
                  transform: expanded ? "rotate(180deg)" : "none",
                  transition: "transform 150ms",
                }}
              >
                <ExpandMoreIcon fontSize="small" />
              </IconButton>
            </Box>
          </InvoiceGrid>

          <InvoiceGrid item xs={ROW_GRID_COLUMNS} sm={ROW_COLUMNS.totalAmount}>
            <TextField
              fullWidth
              size="small"
              type="text"
              label="Total $"
              value={formatNumber({ input: total })}
              variant="outlined"
              disabled
            />
          </InvoiceGrid>

          <InvoiceGrid item xs={ROW_GRID_COLUMNS} sm={ROW_COLUMNS.totalQuantity}>
            <TextField
              fullWidth
              size="small"
              type="text"
              label="Total Lt"
              value={formatNumber({ input: quantity })}
              variant="outlined"
              disabled
            />
          </InvoiceGrid>
        </Grid>

        <Collapse in={expanded} unmountOnExit>
          <Grid container spacing={1} sx={{ mt: 0.5 }}>
            {taxBreakdown.map((tax) => (
              <TaxBreakdownAccordion
                key={`${creLicense}_${tax.taxRate}`}
                data={tax}
                creLicense={creLicense}
                selectedPayments={selectedPayments}
                onTogglePayment={onTogglePayment}
                originalPayments={originalPayments}
              />
            ))}
          </Grid>
        </Collapse>
      </Grid>
    );
  },
);
